/*
  assets/nibec-recomendados.js · Bigbuda T-0459 (14-oct-2026)
  Medición de «También te recomendamos» en la ficha (snippets/nibec-pdp-recomendados.liquid).
  Un clic en una card recomendada publica nibec_recomendado_click (Shopify.analytics y dataLayer) con la ficha
  de origen, el producto de destino, la posición (1 o 2) y el dispositivo. No cambia nada visible ni la navegación.
  Heatmap lee data-hm-id="pdp-recomendado-N" en cada card.
*/
(function () {
  if (window.__nibecRecomendados) return;
  window.__nibecRecomendados = true;

  document.addEventListener(
    'click',
    function (e) {
      var item = e.target && e.target.closest ? e.target.closest('[data-nibec-rec]') : null;
      if (!item) return;
      var enlace = e.target.closest('a, button');
      var datos = {
        origen: location.pathname.split('/').filter(Boolean).pop() || '',
        destino: item.getAttribute('data-nibec-rec') || '',
        posicion: parseInt(item.getAttribute('data-nibec-rec-pos'), 10) || 0,
        elemento: enlace ? enlace.tagName.toLowerCase() : 'card',
        dispositivo: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador'
      };
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('nibec_recomendado_click', datos);
      } catch (err) {}
      try {
        (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'nibec_recomendado_click' }, datos));
      } catch (err) {}
    },
    true
  );
})();
